/*
Akhila 12/26/2022 3075154998 Added Add Rule Popup
Suresh Peddavoora 12/30/2022 3075154998 Added classname for Enter value textfield
Akhila 12/30/2022 3075154998 Added Field Validation
sai krisha 01/06/2023 3075154998 added AND OR auto populate functionality
Suresh Peddavoora 01/06/2022 3075154998 Added classname for Font size Enhancements
Sohel 06/01/2023 3075154998 Added Condition dropdown
Sohel 06/01/2023 3075154998 clear condition
Dilip 09/01/2023 3075154998 added check syntax functionality
Dilip 12/01/2023 3075154998 removed condition for check syntax functionality
Sohel 01/12/2023 2698964415 Added Pre Processor payload Changes
Sohel 01/12/2023 2698964415 Fixed Page Break issue
Sohel 01/13/2023 2701334326 hide value field based on Condition
Dilip 12/01/2023 3075154998 added condition for check syntax functionality
Prakash 01/16/2023 3075154998 Fixed Responsiveness issues.
Akhila 01/18/2023 3075154998 bug fixed page break issue
Akhila 01/20/2023 3075154998 success Validation issue on reset bug fixed
Sohel 01/24/2023 3075154998 check syntax payload changes
Sohel 01/24/2023 2698964415 removed space between Temp repo
Ravi 01/30/2023 2698964415 fixed validation issue in preprocessor
Ashraf 02/02/2023 2698964415 fixed is blank expression
Prakash 02/16/2023 2698403495 Fixed UI-Bug.
Sohel 02/21/2023 2698964415 Audit Field List Changes
suresh peddavoora 02/22/2023 2698964415 New UI changes fixed
Sohel 02/28/2023 2698964415 fixed check syntax payload issue
Rohini 02/28/2023 2698964415 added the class namefor the button
Sohel 02/29/2023 2698964415 fixed export template record dropdown issue
Prakash 03/29/2023 2698964415 Added outlet spacings.
Sohel 03/29/2023 2698964415 audit fields constant changes
Sohel 04/04/2023 2698964415 By pass Record Changes
Sohel 04/06/2023 2698964415 allowed imports By pass Record
Sohel 04/07/2023 2698964415 By pass Changes
Sohel 06/16/2023 2698964415 Changed Fields API in Action and Condition
Sohel 10/10/2023 2700912712 Fixed Repository Name Space Issue
Sohel 10/16/2023 2700912712 changed Field Dropdown value.
*/
import {Button, FormHelperText, makeStyles, TextField, Tooltip} from '@material-ui/core';
import {Form, Formik} from 'formik';
import React, {useEffect, useRef, useState} from 'react';
import {useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {fetchFunctionDetailsById} from '../../../../../../redux/reducers/BRE/AddRuleGroup';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import PageLoader from '../../../../../../components/PageLoader';
import './styles.scss';
import DMRaddRuleSelectFields from '../DMRaddRule/DMRaddRuleSelectFields';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import * as Yup from 'yup';
import {getDataManagerOptions as getOptions} from '../../../../../../components/SqlRuleBuilder/utils';
import {httpPost} from '../../../../../../util/Rest';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: '600',
  },
}));

const DMRaddRule = ({
  rowData,
  isEditMode,
  setIsEditMode,
  ruleGroupSNo,
  setOpen,
  formData,
  setFormData,
  oldRuleCode,
  conditionalProps,
  managerRecordGroup = false,
}) => {
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isBlankCondition, setBlankCondition] = useState('');
  const [formValues, setFormValues] = useState('');
  const {
    allFunctions = [],
    functionDetails,
    operatorsDropdownData,
  } = useSelector(({addRuleGroup}) => addRuleGroup);
  const {recordCode} = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {groupCode} = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const {name, handleValueChange, value, resultRef, exportManagerRecord} = conditionalProps;
  const getConditions = (values) => {
    if (
      ['temporary_repo.bypassrec', 'temporary_repo.bypass']?.includes(
        values?.selectField?.repositoryName + '.' + values?.selectField?.fieldName,
      )
    ) {
      return [
        {label: 'Is', value: '='},
        {label: 'Is not', value: '<>'},
      ];
    } else {
      return getOptions(values?.selectField?.dataType?.toLowerCase());
    }
  };
  const {selectedFields} = useSelector(
    ({dataManagerRecord}) => dataManagerRecord,
  );
  console.log(selectedFields,"selectedFields")
  const selectedProcessorFields =
  selectedFields?.length > 0 ?
    selectedFields?.map((el) => {
      if (el?.fieldType === 'Audit Field') {
        return {
          ...el,
          repositoryName: 'aud.' + el.repositoryName,
        };
      } else {
        return {
          ...el,
        };
      }
    }) :
    [];
  const data = [...value?.conditions];
  const condition = data?.filter(
    (el) =>
      el?.selectField?.repositoryName + '.' + el?.selectField?.fieldName ===
      'temporary_repo.bypassrec',
  );
  const conditionBypass = data?.filter(
    (el) =>
      el?.selectField?.repositoryName + '.' + el?.selectField?.fieldName === 'temporary_repo.bypass',
  );
  if (!condition?.length) {
    selectedProcessorFields?.unshift({
      repositoryName: 'temporary_repo',
      fieldName: 'bypassrec',
      dataType: 'Text',
    });
  } else if (condition?.length > 0) {
    selectedProcessorFields?.filter(
      (el) =>
        el?.selectField?.repositoryName + '.' + el?.selectField?.fieldName !==
        'temporary_repo.bypassrec',
    );
  }
  if (!conditionBypass?.length) {
    selectedProcessorFields?.unshift({
      repositoryName: 'temporary_repo',
      fieldName: 'bypass',
      dataType: 'Text',
    });
  } else if (conditionBypass?.length > 0) {
    selectedProcessorFields?.filter(
      (el) =>
        el?.selectField?.repositoryName + '.' + el?.selectField?.fieldName !==
        'temporary_repo.bypass',
    );
  }
  const hideValueField = ['isBlank', 'isNotBlank'];
  const handleMessage = () => {
    setErrorMessage(null);
    setSuccessMessage(null);
  };
  const dispatch = useDispatch();
  const expressionRef = useRef();
  const initialVal = {
    function: null,
    expression: '',
    operators: null,
    selectField: '',
    condition: '',
  };
  const [initialValues, setInitialValues] = useState(initialVal);
  const validation = Yup.object().shape({
    // selectField: Yup.mixed().required("Field is required"),
    condition: Yup.mixed().required('condition is required'),
    expression: Yup.mixed().test('hide or not', 'Value is required', (value, ctx) => {
      if (!value && !hideValueField?.includes(ctx?.parent?.condition?.value)) {
        return false;
      } else {
        return true;
      }
    }),
  });

  useEffect(() => {
    if (allFunctions && allFunctions.length > 0) {
      const initialValues = {
        ruleCode: isEditMode ?
          rowData && rowData.ruleCode :
          ruleGroupSNo ?
            ruleGroupSNo > 9 ?
              'C' + ruleGroupSNo :
              'C' + ruleGroupSNo :
            isEditMode && rowData && rowData.ruleCode ?
              rowData.ruleCode :
              '',
        expression: isEditMode && rowData && rowData.expression ? rowData.expression : '',
        selectField: isEditMode && rowData && rowData.selectField ? rowData.selectField : '',
        condition:
          isEditMode && rowData && rowData?.condition ?
            getOptions(rowData?.selectField?.dataType?.toLowerCase()).filter(
              (el) => el.value === rowData.condition,
            )[0] :
            '',
      };
      setInitialValues((prev) => ({...prev, ...initialValues, function: allFunctions[0]}));
      dispatch(fetchFunctionDetailsById(allFunctions[0].dataCalculationFunctionId));
    }
  }, [allFunctions]);
  useEffect(() => {
    if (operatorsDropdownData && operatorsDropdownData.length > 0) {
      setInitialValues((prev) => ({...prev, operators: operatorsDropdownData[0]}));
    }
  }, [operatorsDropdownData]);
  const handleCheckSyntax = (values, type) => {
    if (values?.selectField?.dataType && (values?.expression?.trim() || type === 'blank')) {
      setIsLoading(true);
      const payload = {
        code: managerRecordGroup ? groupCode : recordCode,
        condition:
          type === 'blank' ?
            isBlankCondition?.value :
            values?.condition?.value ?
              values?.condition?.value :
              '',
        lhsField: values?.selectField?.repositoryName ?
          values?.selectField?.repositoryName +
            '.' +
            values?.selectField?.fieldName :
          '',
        dataType: values?.selectField.dataType,
        ruleExpression: values?.expression ? values?.expression : '',
        fileType: exportManagerRecord ? 'Export' : 'Import',
        moduleType: managerRecordGroup ? 'Record Group' : 'Record',
      };
      httpPost(`rules/validate/dmrule`, payload)
        .then((response) => {
          console.log(response, 'res');
          if (response?.data?.status === 400) {
            setIsLoading(false);
            setErrorMessage(response?.data?.message);
            setSuccessMessage(null);
          } else if (response?.status === 200) {
            setIsLoading(false);
            setSuccessMessage(response?.response);
            // handleSubmission({...values, formulaExpression: response?.response});
            setErrorMessage(null);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setErrorMessage(error);
        });
    }
  };

  useEffect(() => {
    if (isBlankCondition?.value === 'isBlank' || isBlankCondition?.value === 'isNotBlank') {
      handleCheckSyntax(formValues, 'blank');
    }
  }, [isBlankCondition, formValues]);

  const handleSubmit = (values) => {
    const data = {...values};
    const copyData = [...value?.conditions];

    if (!isEditMode) {
      const newRuleCount =
        value.conditions.length > 0 &&
        Number(value.conditions[value.conditions.length - 1].ruleCode.slice(1)) + 1;
      const newRuleCode = value.conditions.length > 0 ? 'C' + newRuleCount : 'C1';
      if (!resultRef.current && value['resultExpCondition']) {
        const result = value.conditions.map((el, i) => el.ruleCode);
        result.push(newRuleCode);
        // setValueRuleGroup(
        //   "sqlExpression",
        //   result.join(` ${values["resultExpCondition"]} `)
        // );
        handleValueChange(`${name}.result`, result.join(` ${value['resultExpCondition']} `));
      }
      copyData.push({
        ...data,
        ruleCode: newRuleCode,
        expression: values.expression?.trim(),
        tableData: {checked: true},
        selectField: values?.selectField,
        condition: values?.condition?.value,
        rhsFormulaExpression: successMessage,
      });
      // setFormData(copyData);
      handleValueChange(`${name}.conditions`, copyData);
      setOpen(false);
    } else {
      const updatedData = copyData.map((each) => {
        if (each.ruleCode === oldRuleCode) {
          return {
            ...each,
            ruleCode: data.ruleCode,
            expression: values?.expression?.trim(),
            selectField: values?.selectField,
            condition: values?.condition?.value,
            rhsFormulaExpression: successMessage,
          };
        } else {
          return {...each};
        }
      });
      // setFormData(updatedData);
      handleValueChange(`${name}.conditions`, updatedData);
      setOpen(false);
      setIsEditMode(false);
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validation}
      enableReinitialize
      onSubmit={(values) => handleSubmit(values)}
    >
      {(props) => {
        const {values, handleChange, setFieldValue, resetForm, touched, errors} = props;
        return (
          <>
            <Form noValidate>
              <div
                style={{
                  padding: '0rem 1rem',
                }}
              >
                {/* <div className="d-flex mb-3"></div> */}
                <div className="row">
                  <DMRaddRuleSelectFields
                    label={'Functions'}
                    options={allFunctions}
                    value={values?.function}
                    name="function"
                    handleChange={(_, value) => {
                      console.log(value, 'allFunctionValue');
                      setFieldValue('function', value);
                      dispatch(fetchFunctionDetailsById(value?.dataCalculationFunctionId));
                    }}
                    handleInsert={() => {
                      handleMessage();
                      const selectedFunc = functionDetails?.syntax;
                      const cursorPosition = expressionRef.current?.selectionStart;
                      if (values?.expression) {
                        setFieldValue(
                          'expression',
                          values?.expression?.slice(0, cursorPosition) +
                            selectedFunc +
                            values?.expression?.slice(cursorPosition),
                        );
                        expressionRef.current?.focus();
                      } else {
                        setFieldValue('expression', selectedFunc);
                      }
                    }}
                    optionLable={(option) => option.functionName}
                  />
                  <DMRaddRuleSelectFields
                    label={'Fields'}
                    options={selectedProcessorFields?.length > 0 ? selectedProcessorFields : []}
                    renderOption={(props, item) => {
                      return (
                        <li {...props} key={item.key}>
                          {props.key}
                        </li>
                      );
                    }}
                    optionLable={(option) => {
                      return option ?
                        (
                          option?.repositoryName +
                            '.' +
                            option?.fieldName
                        ) :
                        '';
                    }}
                    handleChange={(_, value) => {
                      setFieldValue('fields', value);
                    }}
                    handleInsert={() => {
                      handleMessage();
                      const selectedFunc = values?.fields?.repositoryName ?
                        `${values?.fields?.repositoryName
                        }.${values?.fields?.fieldName}` :
                        '';
                      const cursorPosition = expressionRef.current?.selectionStart;
                      if (values.expression) {
                        setFieldValue(
                          'expression',
                          values.expression.slice(0, cursorPosition) +
                            selectedFunc +
                            values.expression.slice(cursorPosition),
                        );
                        expressionRef.current?.focus();
                      } else {
                        setFieldValue('expression', selectedFunc);
                      }
                    }}
                  />

                  <DMRaddRuleSelectFields
                    label="Operators"
                    options={operatorsDropdownData || []}
                    optionLable={(option) => `${option?.valueCode || ''} ${option?.value || ''}`}
                    handleChange={(_, value) => {
                      setFieldValue('operators', value);
                    }}
                    value={values.operators}
                    handleInsert={() => {
                      handleMessage();
                      const selectedFunc = values?.operators?.valueCode ?
                        `${values?.operators?.valueCode}` :
                        '';
                      const cursorPosition = expressionRef.current?.selectionStart;
                      if (values.expression) {
                        setFieldValue(
                          'expression',
                          values.expression.slice(0, cursorPosition) +
                            selectedFunc +
                            values.expression.slice(cursorPosition),
                        );
                        expressionRef.current?.focus();
                      } else {
                        setFieldValue('expression', selectedFunc);
                      }
                    }}
                  />
                </div>

                {functionDetails && 'functionName' in functionDetails && (
                  <Accordion className="accordion-styling function-usage-accordion">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={classes1.heading}>Function Usage Help</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="function-usage">
                        <p>
                          <span>Function:</span>
                          {functionDetails?.functionName}
                        </p>
                        <p>
                          <span>Description:</span> {functionDetails?.description}
                        </p>
                        <p>
                          <span>Syntax:</span> {functionDetails?.syntax}
                        </p>
                        <p>
                          <span>Example:</span> {functionDetails?.example}
                        </p>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                )}

                {/* <div className="expression-textfield">
                  <TextField
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Expression`}
                    className={` ${classes.labelName} ${classes.inputLabel} `}
                    label="Expression"
                    multiline
                    minRows={2}
                    maxRows={2}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="expression"
                    required
                    value={values.expression}
                    onChange={(e) => {
                      setErrorMessage(null);
                      setSuccessMessage(null);
                      handleChange(e);
                    }}
                    inputRef={expressionRef}
                    fullWidth
                  />
                </div> */}
                <div className="form-row mt-3 global-field-textfields new-standard-textfields">
                  {/* <DMRaddRuleSelectFields
                    label={"Fields"}
                    options={selectedProcessorFields?.length > 0 ? selectedProcessorFields : []}
                    optionLable={(option) => {
                      return option
                        ? (option?.repositoryName + "." + option?.fieldName)?.toLowerCase()
                        : "";
                    }}
                    handleChange={(_, value) => {
                      setFieldValue("fields", value);
                    }}
                    handleInsert={() => {
                      const selectedFunc = values?.fields?.repositoryName
                        ? `${values?.fields?.repositoryName?.toLowerCase()}.${values?.fields?.fieldName?.toLowerCase()}`
                        : "";
                      let cursorPosition = expressionRef.current.selectionStart;
                      if (values.expression) {
                        setFieldValue(
                          "expression",
                          values.expression.slice(0, cursorPosition) +
                            selectedFunc +
                            values.expression.slice(cursorPosition)
                        );
                        expressionRef.current.focus();
                      } else {
                        setFieldValue("expression", selectedFunc);
                      }
                    }}
                  /> */}
                  <div className="col-md-4">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="selectField"
                      id="selectField"
                      size="small"
                      value={values.selectField}
                      options={selectedProcessorFields?.length > 0 ? selectedProcessorFields : []}
                      getOptionLabel={(option) => {
                        return option ?
                          (
                            option?.repositoryName +
                              '.' +
                              option?.fieldName
                          ) :
                          '';
                      }}
                      onChange={(e, value) => {
                        handleMessage();
                        setFieldValue('condition', '');
                        setFieldValue('selectField', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={`${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            error={Boolean(touched?.selectField && errors?.selectField)}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            label="Field"
                            placeholder="Select Field"
                          />
                        </div>
                      )}
                    />
                    <FormHelperText variant="outlined">
                      {touched?.selectField && errors?.selectField ? errors.selectField : ''}
                    </FormHelperText>
                  </div>
                  {/* <DMRaddRuleSelectFields
                    label="Condition"
                    options={conditionDropdown}
                    optionLable={(option) => `${option?.value || ""}`}
                    handleChange={(_, value) => {
                      setFieldValue("condition", value);
                    }}
                    value={values.condition}
                    handleInsert={() => {
                      const selectedFunc = values?.condition?.value
                        ? `${values?.condition?.value}`
                        : "";
                      let cursorPosition = expressionRef.current.selectionStart;
                      if (values.expression) {
                        setFieldValue(
                          "expression",
                          values.expression.slice(0, cursorPosition) +
                            selectedFunc +
                            values.expression.slice(cursorPosition)
                        );
                        expressionRef.current.focus();
                      } else {
                        setFieldValue("expression", selectedFunc);
                      }
                    }}
                  /> */}
                  {values?.selectField?.dataType && (
                    <div className="col-md-4 col-lg-3">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="condition"
                        id="condition"
                        size="small"
                        value={values.condition}
                        options={getConditions(values)}
                        getOptionLabel={(option) => {
                          return option ? option?.label : '';
                        }}
                        onChange={(e, value) => {
                          handleMessage();
                          setFieldValue('condition', value);
                          setFieldValue('expression', '');
                          setBlankCondition(value);
                          setFormValues(values);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={`${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              error={Boolean(touched?.condition && errors?.condition)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              required
                              label="Condition"
                              placeholder="Select Condition"
                            />
                          </div>
                        )}
                      />
                      <FormHelperText variant="outlined">
                        {touched?.condition && errors?.condition ? errors.condition : ''}
                      </FormHelperText>
                    </div>
                  )}

                  {/* <div > className="expression-textfield" */}
                  {!hideValueField?.includes(values?.condition?.value) && values?.condition?.value && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <TextField
                          className={`${classes.labelName} text-description-fields`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter the value with Data Type ${values?.selectField?.dataType}`}
                          label="Value"
                          error={Boolean(touched?.expression && errors?.expression)}
                          multiline
                          minRows={2}
                          maxRows={2}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="expression"
                          required
                          value={values.expression}
                          onChange={(e) => {
                            setFieldValue('expression', e.target.value);
                            setErrorMessage(null);
                            setSuccessMessage(null);
                            handleChange(e);
                          }}
                          inputRef={expressionRef}
                          fullWidth
                        />
                        {errorMessage && <div className="error-text">{errorMessage}</div>}
                        {successMessage && <div className="success-text">Expression is valid</div>}
                      </div>
                    </div>
                  )}
                </div>
                {/* <>
                  {errorMessage && <div className="error-text">{errorMessage}</div>}
                  {successMessage && <div className="success-text">Expression is valid</div>}
                </> */}
                {values?.selectField?.dataType &&
                  !hideValueField?.includes(values?.condition?.value) &&
                  values?.condition?.value && (
                  <div className="new-standard-textfields">
                    <Button
                      variant="outlined"
                      type="button"
                      className={`search-btn ${classes.buttonRoot} mt-2`}
                      onClick={() => handleCheckSyntax(values)}
                    >
                        Check syntax
                    </Button>
                  </div>
                )}
                <div className="d-flex justify-content-center mt-2  new-standard-textfields">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      resetForm(initialValues);
                      setErrorMessage(null);
                      setSuccessMessage(null);
                    }}
                    className={`reset-btn mx-1 ${classes.buttonRoot}`}
                  >
                    Reset
                  </Button>
                  {successMessage ? (
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  ) : hideValueField?.includes(values?.condition?.value) ? (
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  ) : (
                    <Tooltip title="Please check syntax before saving">
                      <span>
                        <Button
                          variant="outlined"
                          disabled={true}
                          className={`search-btn mx-1 ${classes.buttonRoot}`}
                        >
                          Save
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </div>
              </div>
            </Form>
            {isLoading && <PageLoader />}
          </>
        );
      }}
    </Formik>
  );
};

export default DMRaddRule;
